

jQuery3_4_1(document).ready(function($){

    class DDEmitter {
        constructor(){
            this.events = {};
        }
    
        on(eventName, callback) {
            const self = this;
            if (!self.events[eventName]) {
                self.events[eventName] = [];
            }
            self.events[eventName].push(callback);
        }
    
        off(eventName, callback) {
            const self = this;
            const eventHandlers = self.events[eventName];
            if (eventHandlers) {
                self.events[eventName] = eventHandlers.filter(fn => fn !== callback);
            }
        }
    
        emit(eventName, ...args) {
            const self = this;
            const eventHandlers = self.events[eventName];
            if (eventHandlers) {
                eventHandlers.forEach(callback => {
                    callback(...args);
                });
            }
        }
    }

    class RangeSlider {
        constructor(parent){
            if(parent.rangeSlider){
                return;
            }
            parent.rangeSlider = this;
            this.parent = $(parent);
            this.min = this.parent.find(".dd-rangeslider-text-min").data("value");
            this.max = this.parent.find(".dd-rangeslider-text-max").data("value");
            this.setupFormatter();
            this.registerInputs();
            this.storeCurrentValues();
            this.isInputting = false;
            this.currentTarget = false;
            this.emitter = new DDEmitter();  
        }

        on(eventName, callback) {
            this.emitter.on(eventName, callback);
        }

        setupFormatter(){
            const settings = this.parent.data("formatting");
            const locale = settings.locale;
            if ( settings.type === 'date' ) {
                const dateFormatter = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
                this.formatter = { format: function(timestamp){ return dateFormatter.format( new Date(timestamp * 1000) ); } };
                this.isDate = true;
            } else {
                this.formatter = new Intl.NumberFormat(locale, settings);
                this.isDate = false;
            }
        }

        didClickClosestToMin(event) {
            const self = this;
            const currentValue = $(event.target).val();
            const distanceToMin = Math.abs(currentValue - self.currentMin);
            const distanceToMax = Math.abs(currentValue - self.currentMax);
            return (distanceToMin < distanceToMax);
        };
        
        registerInputs(){
            const self = this;

            self.parent.on('change', 'input[type=range]', function(event){
                self.emitter.emit("change", self.currentMin, self.currentMax, self, event );
                self.isInputting = false;
                self.currentTarget = false;
            });

            self.parent.on('input', '.dd-rangeslider-input', function(event){
                const type = $(event.target).data("type");
                const value = $(event.target).val();
                if(type ==="min"){
                    self.currentMin = parseInt( value );
                } else {
                    self.currentMax = parseInt( value );
                }
                self.updateText(type, value);
                self.adjustOppositeHandle(type, value);
                self.storeCurrentValues();
            });

            self.parent.on('input', '.dd-rangeslider-input-fallback-receiver', function(event){
                if(!self.currentTarget){
                    self.currentTarget = self.didClickClosestToMin(event) ? "min" : "max";
                }
                const value = $(event.target).val();
                self.updateText(self.currentTarget, value);                
                self.updateSliderHandle(self.currentTarget, value); 
                self.adjustOppositeHandle(self.currentTarget, value);
                self.storeCurrentValues();
                return;
            });
        }

        updateCurrentValue(type, value){
            const self = this;
            if(type ==="min"){
                self.currentMin = value;
            } else {
                self.currentMax = value;
            }
        }

        updateText(type, value){
            const self = this;
            const element = self.parent.find(".dd-rangeslider-text-"+type);
            self.updateElementValue(element, value);
        }

        updateInputMin(value){
            const self = this;
            const element = self.parent.find("input");
            element.prop("min", value)
        }

        updateInputMax(value){
            const self = this;
            const element = self.parent.find("input");
            element.prop("max", value)
        }

        updateInputStep(value){
            const self = this;
            const element = self.parent.find("input");
            element.prop("step", value)
        }

        updateElementValue(element, value){
            const self = this;
            element.data("value", value).attr("data-value", value);
            const formattedValue = self.formatter.format(value);
            element.find(".dd-rangeslider-value").html(formattedValue);
        }

        adjustOppositeHandle(type, value){
            const self = this;
            const otherType = (type == "min") ? "max" : "min";
            const otherElement = self.parent.find(".dd-rangeslider-text-"+otherType);
            const otherValue = otherElement.data("value");
            const forcedValue = (type == "min") ? Math.max(otherValue, value) : Math.min(otherValue, value); 
            self.updateElementValue(otherElement, forcedValue);
            self.updateSliderHandle(otherType, forcedValue); 
        }

        storeCurrentValues(){
            const self = this;
            self.currentMin = parseInt( self.parent.find(".dd-rangeslider-text-min").data("value") );
            self.currentMax = parseInt( self.parent.find(".dd-rangeslider-text-max").data("value") );
        }

        updateSliderHandle(type, value){
            const self = this;
            const element = self.parent.find(".dd-rangeslider-input-"+type);
            element.val(value)
        }

        reset(){
            const self = this;
            self.updateText("min", self.min);
            self.updateText("max", self.max);
            self.updateSliderHandle("min", self.min); 
            self.updateSliderHandle("max", self.max); 
            self.storeCurrentValues();
        }

        set(args){
            const self = this;
            if(typeof args !== 'object' || !args.min || !args.max){
                console.error("The argument must be an object containing the two properties: min and max.", args);
                return;
            }
            self.min = args.min;
            self.max = args.max;
            self.updateInputMin(args.min);
            self.updateInputMax(args.max);
            self.updateText("min", args.min);
            self.updateText("max", args.max);
            self.updateSliderHandle("min", args.min); 
            self.updateSliderHandle("max", args.max); 
            self.storeCurrentValues();
        }

        setMin(value){
            const self = this;
            value = parseInt(value);
            const args = {
                min:value,
                max:Math.max(value, self.currentMax),
            }
            self.set(args);
        }

        setMax(value){
            const self = this;
            value = parseInt(value);
            const args = {
                min:Math.min(value, self.currentMin),
                max:value,
            }
            self.set(args);
        }

        setStep(value){
            const self = this;
            value = parseInt(value);
            self.updateInputStep(value);
        }
    }

    registerOnLoadEvent(function(){
        $(".dd-rangeslider").each(function(){
            new RangeSlider(this);
        })
    });
});